const WORDS = [
  "Delivered with Speed",
  "Built for Scale",
  "Pre-Vetted Talent",
  "24–48hr Turnaround",
  "Pune · Vadodara",
  "Cloud · AI · ERP",
  "Enterprise Momentum",
];

export default function Marquee() {
  const track = [...WORDS, ...WORDS, ...WORDS];
  return (
    <section
      className="relative py-14 sm:py-16 border-y border-slate-200 bg-white overflow-hidden"
      data-testid="marquee-section"
    >
      <div className="flex whitespace-nowrap vss-marquee-track">
        {track.map((w, i) => (
          <div
            key={i}
            className="flex items-center gap-8 sm:gap-14 pr-8 sm:pr-14 font-display text-3xl sm:text-5xl lg:text-6xl font-extrabold tracking-tight"
          >
            <span className={i % 2 === 0 ? "text-slate-900" : "font-serif-a italic font-normal text-slate-500"}>
              {w}
            </span>
            <span className="brand-gradient text-2xl sm:text-3xl">✦</span>
          </div>
        ))}
      </div>
    </section>
  );
}
